import LayoutSubmaster from "../../components/layoutSubmasterConfig/layoutSubmaster"
import { useEffect, useState } from "react";
import Layout from "../../components/layoutMasterConfig/layoutMaster";
import { setupAPIclient } from "../../services/setupAPIclientAuth";
import { toast } from "react-toastify";
import { Zip_Code_Api } from "../../services/zip_code_api/zip_code_api";
import DataTable, { TableColumn } from "react-data-table-component";
import { apiClientMater } from "../../services/setupClientMaster/apiClientMaster";
import LocalStorage from "../../helpers/localstorage";
import { apiClientSubmaster } from "../../services/setupClientSubmaster/apiClientSubmaster";



function ConfigSubmasterAnimalPage(){


    const getAuthToken = () => {
        const localStorage = new LocalStorage()
        return localStorage.getAuthToken();
    }
    const getStorage = () => {
        const localStorage = new LocalStorage()
        return localStorage;
    }


    const token = String(getAuthToken());

    
    const marginFilter = { marginLeft: "-0.3%"};
    type DataRowAnimal = {
        id: number;
        name: string;
        breed: string;
        speciesofdog:string;
        pet_size:string;
        sex:string
    };
    const [filterText, setFilterText] = useState(""); 
   const [showModalAnimal , setShowModalAnimal ] = useState(false);
    const [showAnimalFormUpdate ,setShowFormUpdateAnimal ] = useState(false);
    const [formDataAnimal , setFormDataAnimal] = useState<{    
        name: string;
        breed:string;
        speciesofdog:string;
        pet_size:string;
        sex:string

     }>({
        name: "",
        breed: "",
        speciesofdog:"",
        pet_size:"",
        sex:""

    });
    function handleChangeAnimal(e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>){
         const { name, value } = e.target;  
         setFormDataAnimal({
           ...formDataAnimal,  
           [name]: value, 
         });
    };
    const resetFormAnimal  = (enableModalAnimal:boolean) => {
        setFormDataAnimal({
            name: '',
            breed:"",
            speciesofdog:"",
            pet_size:"",
            sex:""
        });
        if(enableModalAnimal){
        setShowModalAnimal(true)
        }
    };
     async function handleSubmitAnimal(e: React.FormEvent<HTMLFormElement>){
         e.preventDefault();
         if(formDataAnimal.name === ""){
           return  toast.warning("O campo nome não pode estar vazio! ")
         }else{
           const loadingToast = toast.info("Processando... aguarde", {
             autoClose: false, 
         });
         toast.dismiss(loadingToast);
         try {
             const ApiClient = apiClientSubmaster(token);
             const response = await ApiClient.post("/crud/create/AnimalSubmaster", {
                name: formDataAnimal.name,
                submasterId: Number(getStorage().getId()),
                breed: formDataAnimal.breed,
                pet_size: formDataAnimal.pet_size,
                sex:formDataAnimal.sex,
                speciesofdog:formDataAnimal.speciesofdog

             });
             if (response.status >= 200 && response.status < 300) {
                 toast.success("Cadastrado com sucesso! 🎉");
                 resetFormAnimal(false);
                 setTimeout(() => {
                     window.location.reload();
                }, 1000);
             } else {
                 throw new Error(`Erro inesperado: ${response.status}`);
             }
         } catch (error) {
             const errorMessage =  "Erro ao registrar o animal. Tente novamente.";
             toast.error(errorMessage);
         }
         }
    };
    const [filterTextAnimal, setFilterTextAnimal] = useState(""); 
    const [IduserAnimal, setShowIduserAnimal] = useState(0);
    const [getDataAnimal, setgetDataAnimal] = useState<DataRowAnimal[]>([]);
    const columnsAnimal: TableColumn<DataRowAnimal>[] = [
         {
             name: "Nome",
             selector: (row) => row.name, 
             sortable: true,
         },
         {
           name: 'Ações',
           cell: (row: { id: number }) => (
             <button className='btn-sm btn btn-success'  onClick={() => handleButtonUpdateAnimal(row.id)}>Editar</button>
           ),
           ignoreRowClick: true, 
           allowOverflow: true,
           button: true},];
    const handleButtonUpdateAnimal = (id: number) => {
        const selectedItem = getDataAnimal.find((item) => item.id === id);
        setShowIduserAnimal(id)
        setFormDataAnimal({
            name:         selectedItem?.name ?? "",
            breed:        selectedItem?.breed ?? "", 
            pet_size:     selectedItem?.pet_size ?? "",
            sex:          selectedItem?.sex ?? "",
            speciesofdog: selectedItem?.speciesofdog ?? ""
        });
        setShowFormUpdateAnimal(true)
    }
    const filteredDataAnimal = getDataAnimal.filter(
        (item) =>
        item.name?.toLowerCase().includes(filterTextAnimal.toLowerCase()) 
    );
    const handleSubmitUpdateAnimal = async () => {
        if(formDataAnimal.name === ""){
        return  toast.warning("O campo nome não pode estar vazio! ")
        }else{
            const loadingToastAnimal= toast.info("Processando... aguarde", {
                autoClose: false, 
            });
            toast.dismiss(loadingToastAnimal);
            try {
                const ApiClient = apiClientSubmaster(token);
                const response = await ApiClient.post(`/crud/update/AnimalSubmaster/${IduserAnimal}`, {
                    id: IduserAnimal,
                    name: formDataAnimal.name,
                    breed: formDataAnimal.breed,
                    speciesofdog: formDataAnimal.speciesofdog,
                    pet_size: formDataAnimal.pet_size,
                    sex:formDataAnimal.sex 
                });
                // Verifica se a resposta da API indica sucesso
                if (response.status >= 200 && response.status < 300) {
                    toast.success("Atualizado com sucesso!");
            
                    setTimeout(() => {
                        window.location.reload();
                    }, 1000);
                } else {
                    throw new Error(`Erro inesperado: ${response.status}`);
                }
            }
            catch (error) {
                console.error("Erro ao atualizar:", error);
                // Remove o toast de loading (caso esteja sendo usado)
                toast.dismiss(loadingToastAnimal);
                // Exibe uma mensagem de erro apropriada
                toast.error("Erro ao atualizar. Tente novamente.");
            }
        }    
    }
    useEffect(() => {
         const handlegetActivisionDataAnimal = async () => {
           const ApiClient =  apiClientSubmaster(token);
           const response = await ApiClient.post("/crud/getdata/AnimalSubmaster/" + getStorage().getId() + "/false");
     
             console.log("dados response",response.data)
 
             const formattedAnimal = response.data.map((item: any) => ({
                 id: item.id,
                 name: item.name ?? "",
                 breed: item.breed,
                 speciesofdog:item.speciesofdog,
                 pet_size: item.pet_size,
                 sex:item.sex 

             }));
 
     
           setgetDataAnimal(formattedAnimal)
         }
         handlegetActivisionDataAnimal();

    }, []);
    return (
        <LayoutSubmaster>
          <div className="row">
                {!showAnimalFormUpdate ? (
                    <div>
                    <div className="mt-3">
                        <button className='btn btn-success' onClick={() => resetFormAnimal(true)}>
                            Cadastrar animais
                        </button>
                    </div>
                    <div className="row mb-3 mt-3">
                            <div >
                                <h5>Tabela de animais </h5>
                            </div>
                                <div style={marginFilter}>
                                    <input
                                        type="text"
                                        placeholder="Filtrar por animal"
                                        value={filterTextAnimal}
                                        onChange={(e) => setFilterTextAnimal(e.target.value)}
                                        style={{
                                            marginBottom: "10px",
                                            padding: "8px",
                                            width: "30%",
                                            border: "1px solid #ccc",
                                            borderRadius: "5px",
                                        }}/>
                                </div>
                                <DataTable  
                                columns={columnsAnimal}
                                data={filteredDataAnimal}
                                pagination
                                onSelectedRowsChange={(selected) =>
                                    console.log("Selected Rows: ", selected.selectedRows)
                                }
                            />
                        </div>  
                    </div>
                    ) :
                    <div  className="col-md-12 d-flex align-items-center justify-content-center">
                        <div className='card mt-3 col-md-7'>
                            <div className="modal-body">
                                <form  method="POST">
                                    <div className="form-group col-md-12 mt-2 d-flex flex-column align-items-center">
                                        <input
                                            type="text"
                                            className="fadeIn second form-control"
                                            name="name"
                                            id="name"
                                            placeholder="Nome"
                                            value={formDataAnimal.name}
                                            onChange={handleChangeAnimal}
                                            required
                                        />
                                    </div>
                                    <div className="form-group col-md-12 mt-3">
                                        <select
                                            className="fadeIn second form-control"
                                            name="speciesofdog"
                                            id="speciesofdog"
                                            required
                                            value={formDataAnimal.speciesofdog}
                                            onChange={handleChangeBreedSelected}
                                        >
                                            <option value="" disabled>Selecione a espécie</option>
                                            <option value="dog">Cachorro</option>
                                            <option value="cat">Gato</option>
                                            <option value="bird">Pássaro</option>
                                            <option value="reptile">Réptil</option>
                                            <option value="rodent">Roedor</option>
                                        </select>
                                    </div>
                                    <div className="form-group col-md-12 d-flex flex-column align-items-center">
                                        <select
                                            className="fadeIn second form-control"
                                            name="sex"
                                            id="sex"
                                            required
                                            value={formDataAnimal.sex}
                                            onChange={handleChangeBreedSelected}
                                        >
                                            <option value="" disabled>Selecione o sexo</option>
                                            <option value="male">Masculino</option>
                                            <option value="female">Feminino</option>
                                        </select>
                                    </div>
                                    <div className="form-group col-md-12 d-flex flex-column align-items-center">
                                        <select
                                            className="fadeIn second form-control"
                                            name="pet_size"
                                            id="pet_size"
                                            required
                                            value={formDataAnimal.pet_size}
                                            onChange={handleChangeBreedSelected}>

                                            <option value="" disabled>Selecione o porte</option>
                                            <option value="small">Pequeno</option>
                                            <option value="medium">Médio</option>
                                            <option value="large">Grande</option>
                                        </select>
                                    </div>
                                    <div className="form-group col-md-12 d-flex flex-column align-items-center">
                                        <select
                                            className="fadeIn second form-control"
                                            name="breed"
                                            id="breed"
                                            required
                                            value={formDataAnimal.breed}
                                            onChange={handleChangeBreedSelected}>

                                            <option value="" disabled>Selecione a raça</option>
                                            <option value="small">Pitbull</option>
                                            <option value="medium">Labrador</option>
                                        </select>
                                    </div>
                                </form>
                                <div className="modal-footer">
                                    <button className="btn btn-secondary" onClick={() => setShowFormUpdateAnimal(false)}>Fechar</button>
                                    <button className="btn btn-success" onClick={handleSubmitUpdateAnimal}>Editar</button>
                                </div>
                            </div>
                        </div>
                    </div>
                }
          </div>
  

            {/* Modal do Bootstrap animal */}
            {(showModalAnimal && !showAnimalFormUpdate) && (
                <div className="modal fade show d-block">
                    <div className="modal-dialog modal-md">
                        <div className="modal-content">
                            <div className="modal-header">
                                <h5 className="modal-title">Cadastrar animais </h5>
                                <button type="button" className="btn-close" onClick={() => setShowModalBreed(false)}></button>
                            </div>
                            <div className="modal-body">
                               <form  method="POST">
                                    <div className="form-group col-md-12 mt-2 d-flex flex-column align-items-center">
                                        <input
                                            type="text"
                                            className="fadeIn second form-control"
                                            name="name"
                                            id="name"
                                            placeholder="Nome"
                                            value={formDataAnimal.name}
                                            onChange={handleChangeAnimal}
                                            required
                                        />
                                    </div>
                                    <div className="form-group col-md-12 mt-3">
                                        <select
                                            className="fadeIn second form-control"
                                            name="speciesofdog"
                                            id="speciesofdog"
                                            required
                                            value={formDataAnimal.speciesofdog}
                                            onChange={handleChangeBreedSelected}
                                        >
                                            <option value="" disabled>Selecione a espécie</option>
                                            <option value="dog">Cachorro</option>
                                            <option value="cat">Gato</option>
                                            <option value="bird">Pássaro</option>
                                            <option value="reptile">Réptil</option>
                                            <option value="rodent">Roedor</option>
                                        </select>
                                    </div>
                                    <div className="form-group col-md-12 d-flex flex-column align-items-center">
                                        <select
                                            className="fadeIn second form-control"
                                            name="sex"
                                            id="sex"
                                            required
                                            value={formDataAnimal.sex}
                                            onChange={handleChangeBreedSelected}
                                        >
                                            <option value="" disabled>Selecione o sexo</option>
                                            <option value="male">Masculino</option>
                                            <option value="female">Feminino</option>
                                        </select>
                                    </div>
                                    <div className="form-group col-md-12 d-flex flex-column align-items-center">
                                        <select
                                            className="fadeIn second form-control"
                                            name="pet_size"
                                            id="pet_size"
                                            required
                                            value={formDataAnimal.pet_size}
                                            onChange={handleChangeBreedSelected}>

                                            <option value="" disabled>Selecione o porte</option>
                                            <option value="small">Pequeno</option>
                                            <option value="medium">Médio</option>
                                            <option value="large">Grande</option>
                                        </select>
                                    </div>
                                    <div className="form-group col-md-12 d-flex flex-column align-items-center">
                                      

                                        <select
                                            className="fadeIn second form-control"
                                            name="breed"
                                            id="breed"
                                            required
                                            value={formDataAnimal.breed}
                                            onChange={handleChangeBreedSelected}>

                                            <option value="" disabled>Selecione a raça</option>
                                            <option value="small">Pitbull</option>
                                            <option value="medium">Labrador</option>
                                        </select>
                                    </div>
                                </form>
                            </div>
                            <div className="modal-footer">
                                <button className="btn btn-secondary" onClick={() => setShowModalAnimal(false)}>Fechar</button>
                                <button className="btn btn-success"   onClick={handleSubmitAnimal}>Salvar</button>

                            </div>
                        </div>
                    </div>
                </div>
          )}
          {/* Background escuro (overlay) */}
          {(showModalAnimal && !showAnimalFormUpdate) && <div className="modal-backdrop fade show"></div>}


        </LayoutSubmaster>
    )

    function handleChangeBreedSelected(event: React.ChangeEvent<HTMLSelectElement>) {
        const { name, value } = event.target; 
        setFormDataAnimal((prev) => ({ ...prev, [name]: value })); 
    }
  
   
}


export default ConfigSubmasterAnimalPage